export default {
    lang: "阿尔巴尼亚语",
    application: {
        name: "Sistemi i publikimit të informacionit",
    },
    ajaxTip: {
        success: "Sukses",
        error: "Dështim",
        noAccess: "Nuk keni qasje në këtë burim",
        notFound: "Burimi i aksesuar nuk ekziston",
        serverBusy: "Serveri është i ngopur",
        timeOut: "Kohë e skaduar",
    },
    menu: {
        home: "Faqja kryesore",
        template: "Menaxhimi i modeleve",
        program: "Menaxhimi i programeve",
        playplan: "Planifikimi i luajtjes",
        device: "Menaxhimi i pajisjeve",
        "source-material": "Menaxhimi i materialeve",
        material: "Materiale",
        checkManage: "Menaxhimi i verifikimit",
        setting: "Rregullimet",
        usercenter: "Qendra e përdoruesve",
        adminManage: "Menaxhimi i pajisjeve",
        schedule: "Gjërat për të bërë",
        capitalassets: "Menaxhimi i aktivëve",
        modifyPassword: "Ndrysho fjalëkalimin",
        logout: "Dil nga hyrja",
        "add": "Shto",
        "edit": "Redakto",
        "delete": "Fshi",
        "view": "Shiko",
        "menu_1": "Faqja Kryesore",
        "menu_2": "Menaxhimi i Dispozitiveve",
        "menu_3": "Redakto (Rregullimet e Avancuara - Redaktimi i Bazë - Ndrysho Rrjetin)",
        "menu_4": "Komandat Instant",
        "menu_5": "Redakto (Transfero Departamentin)",
        "menu_6": "Strategji",
        "menu_7": "Rregullimet e Volumit",
        "menu_8": "Rregullimet e Ndriçimit",
        "menu_9": "Rregullimet e Shkarkimit",
        "menu_10": "Rregullimet e Ushqimit",
        "menu_11": "Vetitë e Dispozitivit",
        "menu_12": "Redakto/Shto",
        "menu_13": "Menaxhimi i Programave",
        "menu_14": "Historia e Publikimit",
        "menu_15": "Fshi (Batch/Individual)",
        "menu_16": "Programet në Publikim",
        "menu_17": "Grupozim",
        "menu_19": "Lista e Programave",
        "menu_20": "Redaktimi i Përmbajtjes",
        "menu_21": "Kopjo Programin",
        "menu_23": "Publiko Programin",
        "menu_24": "Menaxhimi i Mateve",
        "menu_25": "Ngarko",
        "menu_28": "Publikim i Shpejtë",
        "menu_29": "Menaxhimi i Shabllonave",
        "menu_30": "Shabllonet Publike",
        "menu_31": "Përdor Tani",
        "menu_32": "Shabllonet e Mia",
        "menu_33": "Publiko në Shabllonet Publike",
        "menu_35": "Historia e Ndërmarrjes",
        "menu_36": "Menaxhimi i Auditu",
        "menu_37": "Auditi i Programave",
        "menu_38": "Audit (Mirato/Refuzo)",
        "menu_39": "Auditi i Mateve",
        "menu_41": "Historia e Auditu (Operatori)",
        "menu_42": "Historia e Auditu (Auditori)",
        "menu_43": "Shiko Numrin e Miratimeve",
        "menu_44": "Menaxhimi i Organizatës",
        "menu_45": "Menaxhimi i Logjeve",
        "menu_46": "Logjet e Riprodhimit",
        "menu_47": "Logjet e Publikimit",
        "menu_48": "Logjet e Gabimeve",
        "menu_49": "Logjet e Operacioneve",
        "menu_50": "Logjet e Fileve",
        "menu_51": "Logjet e Hyrjes",
        "menu_52": "Miratimi i Përmbajtjes",
        "menu_53": "Hapësira e Ruajtjes",
        "menu_54": "Struktura Organizative",
        "menu_55": "Të Drejtat e Rolëve",
        "menu_56": "Autorizim",
        "menu_57": "Shiko (Të Drejtat e Autorizimit)",
        "menu_58": "Anëtarët e Organizatës",
        "menu_60": "Riset Passwordet e Përdoruesve nënkuptuar",
        "menu_61": "Menaxhimi i Aktivëve",
        "menu_62": "Balanca ime",
        "menu_63": "Shiko (Detajet e Fondit)",
        "menu_64": "Përdorimi im i të Dhënave",
        "menu_65": "Shiko (Detajet e Përdorimit të të Dhënave)",
        "menu_66": "Bli Përdorimi i të Dhënave",
        "menu_67": "Kapaciteti im",
        "menu_68": "Dispozitivet e Mia",
        "menu_69": "Detajet e Porosisë",
        "menu_70": "Shiko (Ricarikim)",
        "menu_71": "Shiko (Shabllonet e Blera)",
        "menu_72": "Shiko (Përdorimi i të Dhënave të Blerë)",
        "menu_73": "Të Drejtat e tjera",
        "menu_74": "Shiko (Statistikat e Mateve dhe Programave)",
        "menu_75": "Shiko (Aktivet)",
        "menu_76": "Shiko (Përdorimi i të Dhënave në Cloud/Statistikat)",
        "menu_77": "Shiko (Statistikat e Dispozitiveve në Linjë)"
    },
    login: {
        terminalServiceSystem: "Sistemi i shërbimeve të terminalit inteligjent",
        accountLogin: "Hyrje me llogari",
        register: "Regjistrohu",
        accountLoginTip: "Hyrje me llogari ekzistuese",
        scanQRCode: "Skanoeni kodin QR",
        readAndAgree: "Unë e kam lexuar dhe pranuar",
        readAndAgreeLink: "Marrëveshja e shërbimit të përdoruesve",
        readAndAgreeAgreement: "Ju lutemi lexoni dhe pranoni Marrëveshjen e shërbimit të përdoruesve",
        forgetpassword: "Harruat fjalëkalimin?",
        resetpassword: "Rivendosni fjalëkalimin",
        phoneEmptyTip: "Ju lutemi vendosni numrin e telefonit",
        nextStep: "Hapi tjetër",
        title: "Mirësevini në hyrje",
        submit: "Hyni",
        userName: "Llogari",
        password: "Fjalëkalim",
        userNameEmptyTip: "Ju lutemi vendosni llogarinë",
        passwordEmptyTip: "Ju lutemi vendosni fjalëkalimin",
        passwordFormatTip: "Ju lutemi vendosni formatin e saktë të fjalëkalimit",
        passwordIsOk: "Ju lutemi vendosni fjalëkalimin e konfirmimit",
        passwordSign: "Ju lutemi vendosni fjalëkalimin",
        codeTip: "Ju lutemi vendosni kodin verifikues",
        phone: "Numri i telefonit nuk mund të jetë i zbrazët",
        code: "Kodi verifikues nuk mund të jetë i zbrazët",
        nickname: "Emri i kompaniës nuk mund të jetë i zbrazët",
        pass: "Fjalëkalimi nuk mund të jetë i zbrazët",
        pwdMessage: "Gjatesia e fjalëkalimit 8~20 karaktere, nuk mund të përmbajë hapsira dhe duhet të përmbajë 3 nga këto: shkronja më të mëdha, shkronja më të vogla, numra, karaktere veçanta",
        pwdMessage01: "Ju lutemi vendosni fjalëkalim me shkronja dhe numra më shumë se 8 shifra",
        pwdMessage02: "Gjatesia e fjalëkalimit 8-20 karaktere",
        pwdMessage03: "Fjalëkalimi nuk mund të përmbajë hapsira",
        pwdMessage04: "Fjalëkalimi duhet të përmbajë tre nga këto: shkronja më të mëdha, shkronja më të vogla, numra, simbola",
        newpassempty: "Fjalëkalimi i ri nuk mund të jetë i zbrazët",
        newpass: "Fjalëkalimet e dy herëve nuk janë të njëjta",
        getcode: "Merrni kodin verifikues",
        format: "Format i pavlefshëm i numrit të telefonit",
        chongfa: "Riapërcim pas sekonda",
        isSend: "Të dërguar",
        noregister: "Nuk keni llogari? Regjistrohu menjëherë",
        Mobile: "Numri i telefonit celular",
        verificationcode: "Kodi verifikues",
        petname: "Nënemër",
        Quickregistration: "Regjistrim i shpejtë",
        xiugaimima: "Ndrysho fjalëkalimin",
        jiumima: "Fjalëkalimi i vjetër",
        xinmima: "Fjalëkalimi i ri",
        zaicishuruxinmima: "Vendosni përsëri fjalëkalimin e ri",
        xiugaichenggong: "Ndryshimi i suksesshëm",
        xiugaishoujihao: "Ndrysho numrin e telefonit celular",
        dengluzhanghao: "Llogaria e hyrjes",
        gongsiid: "ID e kompaniës",
        yonghunicheng: "Nënemër i përdoruesit",
        chuangjianshijian: "Koha e krijimit",
        gongsimingcheng: "Emri i kompaniës",
        denglumima: "Fjalëkalimi i hyrjes",
        jianyi: "Sugjerimi: përdorni fjalëkalim me kombinim shkronja-numra",
        shezhimima: "Vendosni fjalëkalimin",
        shezhishoujihao: "Ndrysho/Vendosni numrin e telefonit celular",
        yibangding: "Të lidhur",
        weibangding: "Pa lidhje",
        zhanghuanquan: "Siguria e llogarisë",
        yonghuxinxi: "Informacionet e përdoruesit",
        zhuceSucMsg: "Urime, regjistrimi u suksesua!",
        verificationcodeSucMsg: "Kodi verifikues u dërgua me sukses！",
        requiredIsEmpty: "Fushat e detyrueshme nuk mund të jenë të zbrazëta！",
        emailObj: {
            title: "Email",
            tit: "Hyrje me email",
            tip: "Ju lutemi vendosni adresën e emailit",
            formatTip: "Ju lutemi vendosni formatin e saktë të adresës së emailit",
        },
        phoneObj: {
            title: "Numri i telefonit celular",
            tit: "Hyrje me telefon celular",
            tip: "Ju lutemi vendosni numrin e telefonit celular",
            formatTip: "Ju lutemi vendosni formatin e saktë të numrit të telefonit celular",
        },
        emailOrPhoneObj: {
            title: "Email ose numri i telefonit celular",
            tit: "Hyrje me email ose numër telefon celular",
            tip: "Ju lutemi vendosni emailin ose numrin e telefonit celular",
            formatTip: "Ju lutemi vendosni formatin e saktë të emailit ose numrit të telefonit celular",
        },
        wechatObj: {
            title: "WeChat",
            tit: "Hyrje me WeChat",
        },
        googleObj: {
            title: "Google",
            tit: "Hyrje me Google",
        },
        confirm: "Konfirmo",
        confirmSubmit: "Konfirmo dhe paraqit",
        cancel: "Anulo",
        close: "Mbylle",
        bindSucMsg: "Lidhja u suksesua",
        toContinueBindAccount: "Vazhdo për të përfunduar lidhjen e llogarisë së tretës",
        bindTip01: "Nuk keni llogari? Regjistrojeni një",
        bindTip02: "Keni tashmë llogari",
        bindTip03: "Llogaria aktuale e tretës nuk është e lidhur me llogarinë e platformës, ju lutemi lidhni llogarinë ekzistuese ose regjistrohuni dhe lidhni llogari të re, nga ardhja do të mund të hyni shpejt.",
        bindTip04: "Lidhni llogarinë ekzistuese",
        bindTip05: "Regjistrohu dhe lidhni llogari të re",
        bindTip06: "Ju keni autorizuar nga tretësi, plotësoni informacionet e hyrjes më poshtë për të përfunduar lidhjen",
        bindSubmit: "Paraqit lidhjen",
        enterAccountTip: "Ju lutemi vendosni emrin e llogarisë",
        RegisterAndBind: "Regjistrohu dhe lidh",
        loginErr: "Emri i përdoruesit ose fjalëkalimi është i gabuar！",
        usercenter: "Qendra e përdoruesve",
        pleaseInputName: "Ju lutemi vendosni emrin",
        operationSuccess: "Operacioni u suksesua！",
        edit: "Ndrysho",
        xiugai: "Modifiko",
        userData: "Profili personal",
        changePassword: "Ndryshimi i fjalëkalimit",
        account: "Llogari",
        userName01: "Emri i përdoruesit",
        phoneNumber: "Numri i telefonit celular",
        role: "Roli",
        createTime: "Koha e krijimit",
        genghuang: "Ndërroni",
        bangding: "Lidh",
        unbind: "Largoni lidhjen",
        plesaseSelectBindingType: "Ju lutemi zgjidhni llojin e lidhjes",
        pleaseConfirmCont: "Ju lutemi konfirmoni se e keni lexuar këtë përmbajtje",
        confirmReadCont: "Unë e kam lexuar këtë përmbajtje",
        frequentTip: "Operacioni është shumë i shpejtë, ju lutemi provoni përsëri më vonë!",
        zhuxiaoBtn: "Fshi llogarinë",
        zhuxiaoTitle: "Fshirja e llogarisë",
        querenZhuxiao: "Konfirmo fshirjen",
        jiXu: "Vazhdo",
        sendCodeBtn: "Dërgoni kodin verifikues",
        passwordIsNotOldPassword: "Fjalëkalimi i konfirmimit nuk përputhet me fjalëkalimin e ri",
        passwordIsOldPassword: "Fjalëkalimi i modifikuar është i njëjti me fjalëkalimin origjinal",
        passFormatError: "Ju lutemi vendosni formatin e saktë të fjalëkalimit",
        oldPassWord: "Fjalëkalimi i vjetër",
        newPassWord: "Fjalëkalimi i ri",
        inputPlaceholder: "Ju lutemi vendosni",
        confirmPassword: "Konfirmo fjalëkalimin",
        zhuxiaoTip: `
            1、Fshirja e llogarisë është një veprim i papërshtatshëm, pasi fshihet llogaria, ju nuk do të mëni të hyni dhe përdorni këtë llogari ose llogaritë e tretës regjistruara/hyra përmes kësaj llogari, ju lutemi ruani vetvetes informacionet dhe të dhënat e lidhura me llogarinë.
            2、Para regjistrimit të kësaj llogari, ju lutemi sigurohuni se keni zbrazur të gjitha aktivet etj. dhe nuk ekziston asnjë dyshim; pasi fshihet llogaria, konsiderohet se ju ke humbur pronësinë e të gjitha aktivëve dhe të drejtave brenda kësaj llogari, dhe nuk mund të rikohen ose kthehen.
            3、Nëse llogaritë regjistruara me të njëjtin numër telefon celular janë fshire 3 herë në total, ky numër telefon celular nuk do të mund të regjistrojë më llogari të reja, dhe gjithashtu nuk do të mund të lidhet me asnjë llogari tjetër.
        `
    },
    home: {
        title: "Faqja kryesore",
        quickOperation: "Operacione të shpejta",
        addDevice: "Shto pajisje",
        publishProgram: "Publiko program",
        publishMaterial: "Publiko materiale",
        makeProgram: "Bëj program",
        uploadMaterial: "Ngarko materiale",
        todayData: "Të dhënat e sotme (përditësuar çdo orë)",
        playNumChart: "Statistika e numrit të luajtjeve",
        deviceOnlineStatus: "Gjendja e pajisjeve në linjë",
        onLineDevice: "Pajisje në linjë",
        unLineDevice: "Pajisje jashtë linjës",
        programPlayTime: "Statistika e kohës së luajtjes së programit",
        downloadSoft: "Ngarkoni softuerin",
        adminApp: "Aplikacioni i përdoruesve të telefonit celular",
        playerApp: "Terminali i luajtjes së publikimit të informacionit",
        downloadAdminApp: "Klikoni për të ngarkuar aplikacionin e përdoruesve",
        downloadPlayerApp: "Klikoni për të ngarkuar terminalin e luajtjes",
        aboutUs: "Rreth nesh",
        userManual: "Manuali i përdoruesit",
        message: "Unë do të lë një mesazh",
    },
    device: {
        inputPlaceholder: "Ju lutemi vendosni",
        selectPlaceholder: "Ju lutemi zgjidhni",
        osTypeStr: "Sistemi i terminalit",
        onLineStatus: "Gjendja në linjë",
        dpi: "Përqendësimi",
        companyDeptIdName: "Organizata e cila i përket",
        deviceGroupIdName: "Grupa e cila i përket",
        editOrMove: "Ndrysho/Hapësin",
        loanOriginationFee: "Taksa e fillimit të kredisë",
        strategyInfoLook: "Shikoni informacionin e strategjisë",
        programLook: "Shikoni programin",
        addEquipments: "Shto pajisje",
        luminanceSet: "Kontrolli i ndriçimit",
        terminal: "Rregullimet e terminalit",
        transferCompany: "Transfero departamentin",
        releasedProgram: "Publiko program",
        screenshot: "Pamje e ekranit",
        changeGroup: "Ndrysho grupin",
        defaultGroup: "Grupa parazgjedhur",
        operation: "Operacion",
        edit: "Ndrysho",
        saveEdit: "Ruaj ndryshimet",
        add: "Shto",
        save: "Ruaj",
        setting: "Rregullime",
        program: "Program",
        unbind: "Largoni lidhjen",
        sleep: "Gjumë",
        wakeup: "Zgjohu",
        restart: "Ristartoj",
        shutdown: "Mbylle",
        reportLog: "Raportoni regjistrin",
        clearPlayData: "Pastro të dhënat e terminalit të luajtjes",
        offlineWarn: "Kjo pajisje është jashtë linjës, ju lutemi provoni përsëri pasi pajisja jetë në linjë！",
        confirmUnbind: "Konfirmoni largimin e lidhjes",
        confirmReset: "Konfirmoni pastrimin",
        confirmDelete: "Konfirmoni fshirjen",
        delete: "Fshi",
        cancelDelete: "Anuloni fshirjen",
        confirmResetSuccess: "Pastrimi u suksesua",
        confirm: "Konfirmo",
        cancel: "Anulo",
        operationSuccess: "Operacioni u suksesua",
        unbindSuccess: "Largimi i lidhjes u suksesua",
        pleaseSelectDevice: "Ju lutemi zgjidhni pajisje",
        pleaseSelectOnlineDevice: "Ju lutemi zgjidhni pajisje në linjë",
        confirmMixOperation: "Pajisjet e zgjedhura përfshijnë pajisje jashtë linjës, kjo rregullim nuk do të funksionojë për pajisjet jashtë linjës, a konfirmoni vazhdimin e operacionit？",
        pleaseSelectDate: "Ju lutemi zgjidhni datën",
        reportSuccess: "Raportimi u suksesua",
        deviceSetting: "Rregullimet e pajisjes",
        default: "Parazgjedhur",
        all: "Gjithë",
        deviceList: "Lista e pajisjeve",
        addDevice: "Shto pajisje",
        department: "Struktura e departamentit",
        deviceType: "Përqendësimi",
        osType: "Sistemi i terminalit",
        onlineState: "Gjendja në linjë",
        online: "Në linjë",
        offline: "Jashtë linjës",
        notActive: "Pa aktivizim",
        search: "Ju lutemi vendosni fjalen kyçe",
        batchOperation: "Operacion i grupit",
        allDevices: "Të gjitha pajisjet",
        deviceAttribute: "Atributet e pajisjes",
        selectReportDate: "Zgjidhni datën e raportimit",
        inputName: "Ju lutemi vendosni emrin",
        inputWidth: "Ju lutemi vendosni gjerësinë",
        inputHeight: "Ju lutemi vendosni lartësinë",
        inputResolutionRatio: "Ju lutemi vendosni një numër të plotë më i madh se 0！",
        inputSort: "Ju lutemi vendosni renditjen",
        serialNum: "Numri i serisë",
        name: "Emër",
        width: "Gjerësi",
        height: "Lartësi",
        resolutionRatio: "Përqendësimi",
        inputResolutionRatioName: "Ju lutemi vendosni emrin e përqendësimit",
        sort: "Renditje",
        personal: "Personale",
        system: "Sistem",
        type: "Lloj",
        systemDefaultSettingUneditable: "Rregullimet parazgjedhura të sistemit nuk janë editueshme!",
        systemDefaultSettingUnDeletable: "Rregullimet parazgjedhura të sistemit nuk janë fshirëse!",
        newz: "Shto të ri",
        total: "Total",
        totalNum: "vija",
        strategyName: "Emri i strategjisë",
        associatedTerminalNum: "Numri i terminalve të lidhur",
        createTime: "Koha e krijimit",
        pleaseSelectStrategy: "Ju lutemi zgjidhni strategjinë！",
        onlySelectOneData: "Mund të zgjidhni vetëm një të dhënë！",
        downloadStrategy: "Ngarkoni strategjinë",
        inputStrategyName: "Ju lutemi vendosni emrin e strategjisë",
        luminanceControl: "Kontrolli i ndriçimit",
        volumeStrategy: "Strategjia e volumin",
        saveSuccess: "Ruajtja u suksesua",
        screenAngle: "Rrotullimi i ekranit(°)",
        startTime: "Koha e fillimit",
        endTime: "Koha e mbarimit",
        repeat: "Përsëritje",
        monday: "Hënë",
        tuesday: "Martë",
        wednesday: "Mërkurë",
        thursday: "Enjte",
        friday: "Premte",
        saturday: "Shtunë",
        sunday: "Diel",
        everyday: "Çdo ditë",
        downloadSpeed: "Shpejtësia e ngarkimit",
        inputDownloadSpeed: "Ju lutemi vendosni shpejtësinë e ngarkimit",
        operator: "Operacion",
        pleaseSelectDeleteData: "Ju lutemi zgjidhni të dhënat për të fshirë！",
        confirmBatchDelete: "A konfirmoni fshirjen e grupit？",
        pleaseInputName: "Ju lutemi vendosni emrin",
        detailSetting: "Rregullimet e detajuara",
        weekPlan: "Plani javor",
        specialDateSetting: "Rregullimet e datës së veçantë",
        weekdayInfo: "Java është një zgjedhje e detyrueshme!",
        volumeInfo: "Volumi është një zgjedhje e detyrueshme!",
        timeError: "Gabim në zgjedhjen e kohës!",
        editSuccess: "Operacioni i editimit u suksesua！",
        addSuccess: "Operacioni i shtimit u suksesua！",
        addSpecialPlan: "Shto plan të veçantë të strategjisë",
        downloadSpeedInfo: "Shpejtësia e ngarkimit:(0 tregon ndalimin e ngarkimit)",
        pleaseSelectStartTime: "Ju lutemi zgjidhni kohën e fillimit",
        pleaseSelectEndTime: "Ju lutemi zgjidhni kohën e mbarimit",
        luminanceError: "Ju lutemi vendosni vlerën e saktë të ndriçimit！",
        defaultLuminance: "Ndriçimi parazgjedhur",
        luminance: "Madhësia e ndriçimit",
        defaultLuminanceInfo: "Ndriçimi parazgjedhur(100 tregon më të ndrijuar,0 tregon më të errët)",
        volume: "Volumi",
        saveLuminance: "Ruaj ndriçimin",
        changeSuccess: "Ndryshimi u suksesua！",
        changeNetwork: "Ndërroni rrjetin",
        netName: "Emri i rrjetit",
        nameempty: "Emri i rrjetit nuk mund të jetë i zbrazët",
        currentNetwork: "Rrjeti aktual",
        ipAddress: "Adresa IP",
        dailyMode: "Modi i përditshëm",
        weeklyMode: "Modi javor",
        turnOnTime: "Koha e startimit",
        turnOffTime: "Koha e mbylljes",
        startSleep: "Fillimi i gjumit",
        endSleep: "Mbarimi i gjumit",
        batchDelInfo: "A konfirmoni fshirjen e elementeve të zgjedhura？",
        timeCannotBeEmpty: "Koha nuk mund të jetë e zbrazët!",
        startUp: "Starto",
        shutDown: "Mbylle",
        volumeSize: "Madhësia e volumin",
        defaultVolume: "Volumi parazgjedhur(100 tregon më të madh,0 tregon heshtur)",
        chooseStartTime: "Ju lutemi zgjidhni kohën e fillimit",
        chooseEndTime: "Ju lutemi zgjidhni kohën e mbarimit",
        saveVolume: "Ruaj volumin",
        screenRotationUnSaved: "Rrotullimi i ekranit nuk është ruajtur",
        volumeSettingUnSaved: "Rregullimet e volumin nuk janë ruajtur",
        luminanceSettingUnSaved: "Rregullimet e ndriçimit nuk janë ruajtur",
        confirmClosePopup: "A konfirmoni mbylljen e këtij dritares pop-up?",
        volumeSettingSuccess: "Modifikimi i volumin u suksesua",
        luminanceSettingSuccess: "Modifikimi i ndriçimit u suksesua",
        advancedSettingUnSaved: "Rregullimet e përparuara nuk janë ruajtur",
        settingTitle: "Rregullimet e terminalit",
        volumeSetting: "Rregullimet e volumin",
        luminanceSetting: "Rregullimet e ndriçimit",
        downloadSetting: "Rregullimet e ngarkimit",
        sleepSetting: "Rregullimet e gjumit",
        onOffSetting: "Startimi/Mbyllja e planifikuar",
        screenRotation: "Rrotullimi i ekranit",
        namingError: "Gabim në emërtim, emri i skedarit nuk mund të përmbajë hapsira！",
        deleteSuccess: "Fshirja u suksesua",
        deleteFolder: "Fshi dosjen",
        pleaseInputDeviceName: "Ju lutemi vendosni emrin e pajisjes",
        pleaseInputDeviceId: "Ju lutemi vendosni ID-në e pajisjes",
        discoverDevice: "Zbuloni pajisjen",
        deviceId: "ID e pajisjes",
        bound: "Të lidhur",
        bind: "Lidh",
        noDevice: "Asnjë pajisje",
        refresh: "Rifresko",
        manualAdd: "Shtimi manual",
        deviceGroup: "Klasifikimi i pajisjeve",
        pleaseSelectGroup: "Ju lutemi zgjidhni grupin！",
        deviceName: "Emri i pajisjes",
        goAdd: "Shko për të shtuar",
        close: "Mbylle",
        bindCountInsufficient: "Numri i lidhjeve të disponueshëm është i pamjaftueshëm, ju lutemi rrisni numrin e pajisjeve përpara se të shtoni！",
        displayNumber: "Numri i shfaqur",
        groupName: "Emri i grupit",
        pleaseSelectGroupName: "Ju lutemi plotësoni emrin e grupit！",
        moveGroup: "Hapësin grupin",
        longitude: "Gjerësia geografike",
        latitude: "Gjatësia geografike",
        nationality: "Kombi",
        province: "Prefekturë",
        city: "Qytet",
        county: "Komunë",
        outNetIp: "IP e rrjetit të jashtëm",
        inNetIp: "IP e rrjetit të brendshëm",
        companyName: "Emri i entreprises",
        Info: "Detaje",
        android: "Android",
        win: "Windows",
        osVersion: "Versioni i sistemit",
        softwareVersion: "Versioni i softuerit",
        diskSize: "Madhësia e hardiskut",
        useSize: "Madhësia e përdorur",
        macAddr: "Adresa MAC",
        longitudeLatitudeInfo: "Gjerësia dhe gjatësia geografike duhet të jenë të zbrazëta ose të plotësuara së bashku!",
        terminalName: "Emri i terminalit",
        terminalGroup: "Grupa e terminalit",
        reportJournal: "A raportohet",
        systemVersion: "Versioni i sistemit",
        storageSpace: "Hapësira e ruajtjes",
        resolution: "Përqendësimi",
        runningMemory: "Memoria e ekzekutimit",
        model: "Modeli",
        registerStatus: "Gjendja e regjistrimit",
        password: "Fjalëkalim",
        passwordInfo: "Ju lutemi vendosni 6 deri në 18 fjalë ose numra!",
        group: "Grup",
        address: "Adresë",
        remark: "Shënim",
        renewalPeriod: "Periudha e rinnovarjes",
        money: "Kostos",
        latitudeInfo: "Ju lutemi vendosni gjatësinë geografike të saktë!",
        totalPayment: "Shuma totale e pagesës",
        longitudeInfo: "Ju lutemi vendosni gjerësinë geografike të saktë!",
        setMeal: "Paketë",
        number: "Numër",
        programName: "Emri i programit",
        playStatus: "Gjendja e luajtjes",
        playType: "Mënyra e luajtjes",
        play: "Luaj",
        pause: "Pauzo",
        playTime: "Koha e luajtjes",
        programDeleted: "Programi është fshiur",
        playSuccess: "Programi është planifikuar për luajtur",
        pauseSuccess: "Pauza u suksesua",
        playCycle: "Luaj në rrotullim",
        playInsert: "Shtojmë luajtje",
        withdrawSuccess: "Rikthimi u suksesua",
        withdrawInfo: "Ju lutemi zgjidhni programin për të rikthyer më parë！",
        programBelong: "Programi i cila i përket",
        checkAll: "Zgjidh të gjitha",
        batchDel: "Fshi grupin",
        delConfirm: "A konfirmoni fshirjen e elementeve të zgjedhura？",
        check: "Zgjedhur",
        noProgram: "Asnjë program",
        details: "Detaje",
        screenshotFail: "Pamja e ekranit dështoi",
        policyName: "Emri i politikës",
        terminalNum: "Numri i terminalve të lidhur",
        powerStrategy: "Strategjia e energjisë",
        pleaseSelectDepartment: "Ju lutemi zgjidhni departamentin！",
        screenshotControl: "Kontrolli i pamjës së ekranit",
        未激活: "Pa aktivizim",
        已激活: "Aktivizuar",
        未绑定: "Pa lidhje",
        已绑定: "Të lidhur",
    },
    programManage: {
        programList: "Lista e programeve",
        publishProgram: "Gjurmimi i publikimit të programit",
        week1: "Hënë",
        week2: "Martë",
        week3: "Mërkurë",
        week4: "Enjte",
        week5: "Premte",
        week6: "Shtunë",
        week7: "Diel",
        monday: "E hënë",
        tuesday: "E martë",
        wednesday: "E mërkurë",
        thursday: "E enjte",
        friday: "E premte",
        saturday: "E shtunë",
        sunday: "E diel",
        name: "Emër",
        preview: "Parapamje",
        playDeviceNum: "Numri i pajisjeve të luajtjes",
        copyDeviceCode: "Klikoni për të kopjuar",
        osType: "Lloji i sistemit",
        playDate: "Data e luajtjes",
        playWeek: "Java e luajtjes",
        everyday: "Çdo ditë",
        start: "Nis",
        end: "Mbaron",
        playOperateStatusStr: "Gjendja e publikimit",
        playDevice: "Pajisja e luajtjes",
        downloadView: "Shikoni ngarkimin",
        publisher: "Publikuesi",
        publishTime: "Koha e publikimit",
        operation: "Operacion",
        add: "Shto",
        groupName: "Emri i grupit",
        selectDevice: "Zgjidhni terminalin",
        searchDevice: "Kërkoni terminalin",
        pleaseFillGroupName: "Ju lutemi plotësoni emrin e grupit！",
        remarkInfo: "Shënim",
        compile: "Ndrysho",
        withdrawConfirm: "A konfirmoni rikthimin e këtij programi？",
        confirm: "Konfirmo",
        cancel: "Anulo",
        withdraw: "Rikthe",
        batchWithdraw: "Rikthe grupin",
        batchPublish: "Publiko grupin",
        batchDelete: "Fshi grupin",
        batchOperation: "Operacion i grupit",
        notUse: "Pa përdorim",
        notChecked: "Pa verifikim",
        notPass: "Pa miratim",
        delete: "Fshi",
        publishTextLeft: "Të publikuar",
        offTextLeft: "Të ndaluar",
        pleaseSelectProgramToMove: "Ju lutemi zgjidhni programin për të transferuar！",
        pause: "Pauzo",
        pauseConfirm: "A konfirmoni pauzën？",
        play: "Luaj",
        downloadUdisk: "Ngarkoni USB",
        deviceList: "Lista e pajisjeve",
        groupSelection: "Zgjedhja e grupit",
        operationSuccess: "Operacioni u suksesua",
        deleteSuccess: "Fshirja u suksesua",
        selectDate: "Zgjidhni datën",
        publishStatus: "Gjendja e publikimit",
        checkStatus: "Gjendja e verifikimit",
        waitAuditing: "En nga verifikohet",
        auditPass: "Verifikimi u përshtati",
        auditRefuse: "Verifikimi u refuzua",
        all: "Gjithë",
        playStatus: "Po luhet",
        playStatust: "Gjendja e luajtjes",
        pauseStatus: "Të ndaluar",
        notStartStatus: "Pa fillim",
        resolutionratio: "Përqendësimi",
        totalNum: "vija",
        programName: "Emri i programit",
        playStartTime: "Koha e fillimit të luajtjes së programit",
        playEndTime: "Koha e mbarimit të luajtjes së programit",
        createTime: "Koha e krijimit",
        nationality: "Kombi",
        province: "Prefekturë",
        city: "Qytet",
        county: "Komunë",
        address: "Adresë",
        ip: "Adresa IP",
        location: "Vendndodhje",
        log: "Regjistër",
        pleaseFillProgramName: "Ju lutemi plotësoni emrin e programit！",
        selectGroup: "Zgjidhni grupin",
        startTime: "Koha e fillimit",
        endTime: "Koha e mbarimit",
        publishCycle: "Cikli i publikimit",
        publishDeviceNum: "Numri i pajisjeve të publikimit",
        pleaseSelectRecord: "Ju lutemi zgjidhni regjistrin",
        deviceName: "Emri i terminalit",
        deviceId: "ID e pajisjes së terminalit",
        deviceGroupIdName: "Grupa ku ndodhet",
        notClassified: "Pa klasifikim",
        osTypeStr: "Sistemi i terminalit",
        storageSpace: "Hapësira e ruajtjes",
        onLineStatus: "Gjendja në linjë",
        onLine: "Në linjë",
        offLine: "Jashtë linjës",
        sleep: "Gjumë",
        unknown: "I panjohur",
        registerStatus: "Gjendja e regjistrimit",
        trialPeriod: "Periudha e provës",
        notActive: "Pa aktivizim",
        active: "Aktivizuar",
        parameterError: "Parametrat janë të gabuara!",
        pleaseSelectProgram: "Ju lutemi zgjidhni programin!",
        pleaseSelectProgramEdit: "Ju lutemi zgjidhni programin për të edituar!",
        confirmWithdrawSelectedProgram: "A konfirmoni rikthimin e programeve të zgjedhura？",
        withdrawSuccess: "Rikthimi u suksesua",
        allPrograms: "Të gjitha programet",
        defaultGroup: "Grupa parazgjedhur",
        cannotShareEmptyProgram: "Nuk mund të ndahet programi i zbrazët！",
        onlyShareYourProgram: "Mund të ndahet vetëm programi juaj i krijuar!",
        pleaseSelectProgramEditPublishTime: "Ju lutemi zgjidhni programin me kohën e publikimit të edituar!",
        pleaseSelectDevice: "Ju lutemi zgjidhni pajisje!",
        programDetail: "Detajet e programit",
        errorReason: "Arsyeja e gabimit",
        availableStorageSpaceInsufficient: "Hapësira e ruajtjes së disponueshme është e pamjaftueshme",
        partialDeviceReleaseFailure: "Publikimi i pjesës së pajisjeve dështoi",
        allDeviceReleaseSuccess: "Publikimi i të gjitha pajisjeve u suksesua",
        partialDeviceReleaseSuccess: "Publikimi i pjesës së pajisjeve u suksesua",
        allGroup: "Të gjitha grupet",
        allProgram: "Të gjitha programet",
        unGrouped: "Pa grupim",
        replaceProgram: "Zëvendësoni programin",
        replaceProgramTip: "Programi i ri të publikuar do të zëvendësojë të dhënat e programit të mëparshëm të terminalit të luajtjes！",
        screen: "Ekran i vetëm/dy ekran",
        singleScreen: "Ekran i vetëm",
        doubleScreen: "Dy ekran",
        playSetting: "Rregullimet e luajtjes",
        batchPlaySetting: "Rregullimi i grupit të kohës së luajtjes",
        individualPlaySetting: "Rregullimi i kohës së luajtjes një nga një",
        playTime: "Koha e luajtjes",
        daily: "Çdo ditë",
        weekdays: "Hënë deri në Premte",
        monthly: "Në muaj të aktual",
        advancedSetting: "Rregullimet e përparuara",
        playProgram: "Luaj programin",
        searchProgram: "Ju lutemi vendosni fjalen kyçe",
        shareAddressNotExist: "Adresa e lidhjes nuk ekziston, ju lutemi provoni përsëri",
        copySuccess: "Kopimi u suksesua",
        shareLink: "Lidhje për ndarje",
        publish: "Publiko",
        noResource: "Asnjë burim",
        single: "Ekran i vetëm",
        double: "Dy ekran",
        time: "Kohë",
        associatedTerminalNum: "Numri i terminalve të lidhur",
        default: "Parazgjedhur",
        moveGroup: "Hapësin grupin",
        pleaseSelectGroup: "Ju lutemi plotësoni emrin e grupit！",
        copy: "Kopjo",
        FUBEN: "Kopje",
        nameempty: "Emri nuk mund të jetë i zbrazët",
        whitespace: "Gabim në emërtim, emri i skedarit nuk mund të përmbajë hapsira！",
        programWhitespace: "Gabim në emërtim, emri i programit nuk mund të përmbajë hapsira！",
        pleaseSelectResolution: "Ju lutemi zgjidhni përqendësimin！",
        dataError: "Të dhënat janë të gabuara！",
        createProgram: "Krijo program të ri",
        directCreate: "Krijo direkt",
        myTemplate: "Modeli im",
        use: "Përdor",
        free: "Pa pagesë",
        loadMore: "Ngarko më shumë",
        confirmDelete: "Konfirmoni fshirjen",
        deleteGroup: "Fshi grupin",
        notPublished: "Pa publikim",
        notPassed: "Pa miratim",
        notUsed: "Pa përdorim",
        confirmDeleteSelectedProgram: "A konfirmoni fshirjen e programeve të zgjedhura？",
        companyName: "Emri i entreprises",
        programCannotDownload: "Ky program nuk mund të ngarkohet！",
        publishMaterial: "Publiko materiale",
        playMaterial: "Luaj materialet",
        pleaseInputMaterialName: "Ju lutemi vendosni emrin e materialit",
        size: "Madhësia",
        pleaseInputDeviceName: "Ju lutemi vendosni emrin e pajisjes",
        item: "vija",
        allMaterial: "Të gjitha materialet",
        allDevices: "Të gjitha pajisjet",
        "saveSuccess": "Ruajtur me sukses",
        "savefaill": "Dështim në ruajtje",
        "playMode": "Modi i riprodhimit",
        "cyclePlay": "Riprodhimi ciklik",
        "insertPlay": "Riprodhimi i futur",
        "noData": "Nuk ka të dhëna",
        "Add": "Shto",
        "replace": "Zëvendëso",
        "repeat": "Përsërit",
        "start01": "Fillim",
        "end01": "Fund",
        "startDate": "Data e fillimit",
        "endDate": "Data e fundit",
        "useNow": "Përdor tani",
        "fillStartEndTimeFirst": "Ju lutemi plotësoni kohën e fillimit dhe fundit përpara se të shtoni",
        "fillFullPlayTime": "Ju lutemi plotësoni kohën e plotë të riprodhimit",
        "fillCorrectPlayTime": "Ju lutemi plotësoni periudhën e saktë të riprodhimit",
        "sDateAndEDateBothEmptyOrFilled": "Data e fillimit dhe data e fundit duhet të jenë të dyja të zbrazëta ose të dyja të plotësuara"
    },
    source: {
        addResource: "Shtimi i burimeve",
        width: "Gjerësi",
        height: "Lartësi",
        size: "Madhësia(KB)",
        name: "Emër",
        pleaseInputResourceName: "Ju lutemi vendosni emrin e burimit！",
        addToGroup: "Shto në grup",
        remark: "Shënim",
        promptFgIllustrate: "Ilustrim",
        promptFgRealisticPhoto: "Fotografi realiste",
        promptFgSimplisticDrawing: "Disej të thjeshtë",
        promptFgChineseStyle: "Stili kinez",
        promptFgPixelArt: "Art piksel",
        noModel: "Asnjë model, ju lutemi kontaktoni administratorin！",
        getModelFailed: "Marrja e modelit dështoi, ju lutemi provoni përsëri më vonë！Ose kontaktoni administratorin！",
        createImagePrompt: "Po gjenerohet imazhi, ju lutemi mbyllni më vonë！",
        promptEmpty: "Ju lutemi vendosni fjalën udhëzuese",
        dpiEmpty: "Ju lutemi zgjidhni raportin e imazhit！",
        fgEmpty: "Ju lutemi zgjidhni stilin！",
        style: "Stil",
        idEmpty: "ID e imazhit nuk mund të jetë i zbrazët",
        exist: "Ky imazh ekziston tashmë në materiale",
        addSuccess: "Shtimi i materialit u suksesua",
        saveError: "Ruajtja e imazhit dështoi, ju lutemi provoni përsëri më vonë！",
        delSuccess: "Fshirja u suksesua",
        generateImage: "Tekst në imazh",
        generateImagePlaceholder: "Ju lutemi vendosni imazhin që dëshironi të gjeneroni, p.sh.: një flutur në fushë me lule që lëviz me lëvizje",
        aiExpand: "Zgjatje inteligjente artificiale",
        negativePrompt: "Fjalë udhëzuese negative",
        negativePromptTooltip: "Përdoret për të ekskluduar përmbajtjen ose veçoritë që përdoruesi nuk dëshiron të shfaqen në dalje",
        imageRatio: "Raporti i imazhit",
        generateImageBtn: "Gjenero menjëherë",
        shengchengjieguo: "Rezultati i gjenerimit",
        generateImageLoadingTip: "Po gjenerohet, ju lutemi mos klikoni përsëri ose mbyllni...",
        Tooltip: "Hidheni krijimin tuaj me AI",
        saveToMaterial: "Ruaj në materiale",
        publish: "Publiko menjëherë",
        download: "Ngarko",
        generateHistory: "Historia e gjenerimit",
        hide: "Fshi",
        cancel: "Anulo",
        useExpand: "Përdor zgjatjen",
        all: "Gjithë",
        delete: "Fshi",
        loadMore: "Ngarko më shumë",
        aiTip: "Përmbajtja është gjeneruar nga modeli i inteligjencës artificiale, nuk përfaqëson pikëpamjen, pozicionin ose qëndrimin e platformës, ju lutemi përdorni përmbajtjen AI në mënyrë të drejtë dhe conforme",
        operationSuccess: "Operacioni u suksesua",
        moveGroup: "Hapësin grupin",
        groupName: "Emri i grupit",
        pleaseSelectGroup: "Ju lutemi zgjidhni emrin e grupit！",
        shenhe: "Verifikim",
        shenheStatus: "Gjendja e verifikimit",
        shenheSuccess: "Verifikimi u përshtati",
        shenheRefuse: "Verifikimi u refuzua",
        pleaseSelectShenheStatus: "Ju lutemi zgjidhni gjendjen e verifikimit！",
        shenheRemark: "Shënim i verifikimit",
        pleaseInputShenheRemark: "Ju lutemi vendosni shënimin e verifikimit！",
        pleaseInputFileName: "Ju lutemi vendosni emrin e skedarit！",
        whitespace: "Gabim në emërtim, emri i skedarit nuk mund të përmbajë hapsira！",
        dataError: "Të dhënat janë të gabuara！",
        confirmDelete: "Konfirmoni fshirjen",
        confirm: "Konfirmo",
        deleteFolder: "Fshi dosjen",
        add: "Shto",
        edit: "Ndrysho",
        fileName: "Emri i skedarit",
        group: "Grup",
        resolution: "Përqendësimi",
        type: "Lloj",
        image: "Imazh",
        music: "Muzikë",
        video: "Video",
        uploadTime: "Koha e ngarkimit",
        uploadUser: "Ngarkuesi",
        checkTime: "Koha e verifikimit",
        checkUser: "Verifikuesi",
    },
    setting: {
        nameempty: "Emri nuk mund të jetë i zbrazët",
        heightempty: "Lartësia nuk mund të jetë e zbrazët",
        widthempty: "Gjerësia nuk mund të jetë e zbrazët",
        resolutionratio: "Përqendësimi",
        name: "Emër",
        opteration: "Operacion",
        compile: "Ndrysho",
        delete: "Fshi",
        newz: "Shto të ri",
        compileratio: "Ndrysho përqendësimin",
        sheizhifenbianlvmingcheng: "Vendosni emrin e përqendësimit",
        shezhigaodu: "Vendosni lartësinë",
        shezhikuandu: "Vendosni gjerësinë",
        xinzengfenbianlv: "Shto përqendësim të ri",
        bianma: "Kodim",
        bianjizhongduanmingcheng: "Ndrysho emrin e terminalit",
        xinzengzhongduan: "Shto terminal të ri",
        selectPrimaryColor: "Zgjidhni ngjyrën themelore",
        fullScreen: "Ekran i plotë",
        exitFullScreen: "Dalje nga ekran i plotë",
    },
    tabs: {
        refresh: "Rifresko",
        refreshAll: "Rifresko të gjitha",
        close: "Mbylle",
        closeOthers: "Mbylle të tjerat",
        closeAll: "Mbylle të gjitha",
        closeLeft: "Mbylle të majtë",
        closeRight: "Mbylle të djathtë",
    },
    errorPage: {
        needLogin: "Ju nuk jeni hyri ende！",
        pageNotFound: "Faqja që ju aksesoni nuk ekziston！",
        redirectTo: "Ridrejtohet te",
        orReturn: "ose kthehu te",
        previousStep: "Hapi i mëparshëm",
    },
    headerUs: {
        systemNotice: "Njoftimet e sistemit",
        allNotices: "Të gjitha njoftimet",
        viewAllMessages: "Shihni të gjitha mesazhet",
        contactUs: "Na kontaktoni",
        operationSuccess: "Operacioni u suksesua！",
        leaveMessage: "Unë do të lë një mesazh",
        messageTitle: "Titulli",
        messageTitleTip: "Ju lutemi vendosni titullin！",
        messageContentTip: "Nëntër 150 karaktere",
        submit: "Paraqit",
        markAsRead: "Shëno si të lexuar",
        success: "Operacioni u suksesua！"
    },
    material: {
        allMaterial: "Të gjitha materialet",
        defaultGroup: "Grupa parazgjedhur",
        auditStatus: "Gjendja e verifikimit",
        auditPassed: "Verifikimi u përshtati",
        auditRejected: "Verifikimi u refuzua",
        pendingAudit: "En nga verifikohet",
        all: "Gjithë",
        operateSuccess: "Operacioni u suksesua！",
        pleaseSelectMaterial: "Ju lutemi zgjidhni materiale！",
        moveGroup: "Hapësin grupin",
        pleaseSelectGroup: "Ju lutemi zgjidhni grupin！",
        batchPublish: "Publiko grupin",
        batchRecall: "Rikthe grupin",
        batchDelete: "Fshi grupin",
        materialList: "Lista e materialeve",
        uploadMaterial: "Ngarko materiale",
        materialType: "Lloji i materialit",
        pleaseInputMaterialName: "Ju lutemi vendosni emrin e materialit",
        selectAll: "Zgjidh të gjitha",
        confirmDeleteSelectedMaterial: "A konfirmoni fshirjen e materialeve të zgjedhura？",
        deleteSuccess: "Fshirja u suksesua",
        delete: "Fshi",
        publish: "Publiko",
        recall: "Rikthe",
        confirmRecallSelectedMaterial: "A konfirmoni rikthimin e materialeve të zgjedhura？",
        pleaseSelectMaterialGroup: "Ju lutemi zgjidhni grupin e materialeve！",
        recallSuccess: "Rikthimi u suksesua",
        publishSuccess: "Publikimi u suksesua",
        batchOperate: "Operacion i grupit",
        item: "vija",
        confirmDelete: "A konfirmoni fshirjen？",
        edit: "Ndrysho",
        confirmRecall: "A konfirmoni rikthimin？",
        unaudited: "Pa verifikim",
        notPassed: "Pa miratim",
        operate: "Operacion",
        resolution: "Përqendësimi",
        none: "Asnjë",
        confirm: "Konfirmo",
        cancel: "Anulo",
        AICreation: "Krijimi AI",
    },
    uploadFile: {
        operationSuccess: "Operacioni u suksesua",
        uploadFile: "Menaxhimi i ngarkimit",
        uploadSuccess: "Ngarkimi u suksesua",
        uploadCompleted: "Ngarkimi u përfundua",
        uploadFail: "Ngarkimi dështoi",
        ConversionFailed: "Konvertimi dështoi！",
        loading: "Po ngarkohet me përpjekje...",
        beQueuing: "Në vështrim...",
        Uploading: "Po ngarkohet...",
        ConversionIng: "Po konvertohet...",
        ConventionalResources: "Burimet konvencionale",
        DocumentResources: "Burimet e dokumenteve",
        complete: "Përfunduar",
        upload: "Ngarko",
        fileSizeWraning01: "Madhësia e materialit tejkalon",
        fileSizeWraning02: "Ju lutemi modifikoni dhe ngarkoni përsëri！",
        fileIsEmpty: "Skedari është i zbrazët",
        uploadFileTip: "Format i skedarit i papërshtatshëm",
        unablePreview: "Nuk u shtua me sukses në librarinë e materialeve, nuk mund të parashikohet",
        confirmDelete: "A konfirmoni fshirjen？",
        deleteSuccess: "Fshirja u suksesua",
        delete: "Fshi",
        confirm: "Konfirmo",
        preview: "Parapamje",
        close: "Mbylle",
        cancel: "Anulo",
        fileType: "Lloji i skedarit",
        fileSize: "Madhësia e skedarit",
        conversionProgress: "Progresi i konvertimit",
        progress: "Progresi",
        image: "Imazh",
        video: "Video",
        audio: "Muzikë",
        limitTip01: "Ngarkim i një",
        limitTip02: "skedarësh në një kohë",
        okTip: "Po ngarkohen materialet, ju lutemi mbyllni më vonë！",
        usableSize: "Madhësia e disponueshme",
        sizeUnableTip: "Hapësira e ruajtjes së disponueshme aktual është e pamjaftueshme, ju lutemi pastroni shpejt materialet e pandorueshme për të kursyer hapësirë ose kontaktoni distributorin për të zgjeruar kapacitetin.",
        view: "Shihni detaje",
        fileName: "Emri i skedarit",
    },
    template: {
        inputPlaceholder: "Ju lutemi vendosni",
        selectPlaceholder: "Ju lutemi zgjidhni",
        noAuths: "Asnjë autorizim, ju lutemi kontaktoni administratorin",
        operationSuccess: "Operacioni u suksesua",
        total: "Total",
        totalNum: "vija",
        dan: "Vetëm",
        shaung: "Dy",
        pleaseSelectGroup: "Ju lutemi zgjidhni grupin",
        preview: "Parapamje",
        free: "Pa pagesë",
        use: "Përdor",
        dpi: "Përqendësimi",
        delete: "Fshi",
        confirmDelete: "Konfirmoni fshirjen",
        confirmDeleteSelectedTemplate: "A konfirmoni fshirjen e këtij modeli",
        push: "Publiko",
        pushConfirm: "A konfirmoni publikimin në modelin publik",
        pushRemovalConfirm: "A konfirmoni heqjen nga modeli publik",
        templateOrderRecord: "Regjistri i porosive të modelit",
        unpublished: "Pa publikim",
        auditing: "En nga verifikohet",
        publishRejected: "Publikimi u refuzua",
        publishSuccess: "Publikimi u suksesua",
        offShelf: "Heq nga shef",
        公共模版: "Modeli publik",
        我的模板: "Modeli im",
        共享记录: "Regjistri i ndarjes",
        name: "Emër",
        pubdate: "Koha e publikimit",
        keySeachTip: "Ju lutemi vendosni fjalen kyçe",
        allGroup: "Të gjitha grupet",
        add: "Shto",
        edit: "Ndrysho",
        programName: "Emri i programit",
        selectGroup: "Zgjidhni grupin",
    },
    checkManage: {
        total: "Total",
        totalNum: "vija",
        operationSuccess: "Operacioni u suksesua",
        checkUserLogs: "Regjistri i verifikimit (operator)",
        checkLogs: "Regjistri i verifikimit (verifikues)",
        sourceCheck: "Verifikimi i materialeve",
        programCheck: "Verifikimi i programeve",
        checkAll: "Zgjidh të gjitha",
        auditPass: "Verifikimi u përshtati",
        auditRefuse: "Verifikimi u refuzua",
        auditPass01: "Përshtat",
        auditRefuse01: "Refuzo",
        auditRefuse02: "Refuzo verifikimin",
        auditor: "Verifikuesi",
        agentUserName: "Publikuesi",
        interrogationTime: "Koha e pyetjes",
        checkTime: "Koha e verifikimit",
        checkName: "Emri i verifikimit",
        checkType: "Kategoria e verifikimit",
        checkIp: "Adresa IP e verifikimit",
        checkReason: "Mesazh",
        checkStatus: "Përmbajtja e operacionit",
        rangePicker: "Data e verifikimit",
        keyWord: "Fjala kyçe",
        all: "Gjithë",
        program: "Program",
        material: "Materiale",
        dan: "Vetëm",
        shaung: "Dy",
        pleaseSelectProgram: "Ju lutemi zgjidhni programin!",
        pleaseSelectMaterial: "Ju lutemi zgjidhni materiale！",
        preview: "Parapamje",
        dpi: "Përqendësimi",
        auditRefuseTip: "Ju lutemi vendosni arsyeja e refuzimit",
        unreviewed: "Pa verifikim",
        notPassed: "Pa miratim",
        notUsed: "Pa përdorim",
        edit: "Ndrysho",
        none: "Asnjë",
        name: "Emër",
        size: "Madhësia",
        type: "Lloj",
        uploadTime: "Koha e ngarkimit",
        uploadUser: "Ngarkuesi",
        checkUser: "Verifikuesi",
        image: "Imazh",
        music: "Muzikë",
        video: "Video",
    },
    systemSet: {
        total: "Total",
        totalNum: "vija",
        inputPlaceholder: "Ju lutemi vendosni",
        selectPlaceholder: "Ju lutemi zgjidhni",
        userList: "Anëtarët e organizatës",
        roleList: "Autorizimet e rolit",
        department: "Struktura e organizatës",
        diskInfo: "Hapësira e ruajtjes",
        approveSet: "Miratoja e përmbajtjes",
        logList: "Menaxhimi i regjistrave",
        name: "Emër",
        account: "Llogari",
        userName: "Emri i përdoruesit",
        phoneNumber: "Numri i telefonit celular",
        role: "Roli",
        createTime: "Koha e krijimit",
        operation: "Operacion",
        edit: "Ndrysho",
        delete: "Fshi",
        addNew: "Shto të ri",
        add: "Shto",
        resetPassword: "Rivendosni fjalëkalimin",
        confirmDelete: "Konfirmoni fshirjen",
        departmentOrganization: "Struktura e departamentit",
        addNewUser: "Shto përdorues të ri",
        pleaseEnterUserName: "Ju lutemi vendosni emrin e përdoruesit",
        confirmPasswordNotMatch: "Fjalëkalimi i konfirmimit nuk përputhet me fjalëkalimin e vendosur!",
        operationSuccess: "Operacioni u suksesua!",
        userNickname: "Emri i përdoruesit",
        pleaseEnterUserNickname: "Ju lutemi vendosni emrin e përdoruesit",
        userNicknameRequired: "Emri i përdoruesit nuk mund të jetë i zbrazët!",
        password: "Fjalëkalim",
        pleaseEnterPassword: "Ju lutemi vendosni fjalëkalimin",
        passwordRequired: "Fjalëkalimi nuk mund të jetë i zbrazët!",
        passwordTip: "Siguria e fjalëkalimit tuaj është shumë e ulët (fjalëkalimi duhet të përmbajë 3 nga këto: shkronja më të mëdha, shkronja më të vogla, numra, karaktere veçanta dhe gjatesia në 8+)",
        confirmPassword: "Konfirmo fjalëkalimin",
        pleaseEnterPhoneNumber: "Ju lutemi vendosni numrin e telefonit celular",
        phoneNumberRequired: "Numri i telefonit celular nuk mund të jetë i zbrazët!",
        phoneNumberFormatError: "Ju lutemi vendosni formatin e saktë të numrit të telefonit celular!",
        roleRequired: "Roli nuk mund të jetë i zbrazët!",
        required: "Nuk mund të jetë i zbrazët!",
        departmentName: "Departament",
        modifyPassword: "Ndrysho fjalëkalimin",
        newPassword: "Fjalëkalimi i ri",
        pleaseEnterNewPassword: "Ju lutemi vendosni fjalëkalimin e ri",
        pwdMessage: "Gjatesia e fjalëkalimit 8~20 karaktere, nuk mund të përmbajë hapsira dhe duhet të përmbajë 3 nga këto: shkronja më të mëdha, shkronja më të vogla, numra, karaktere veçanta",
        all: "Gjithë",
        noAuths: "Asnjë autorizim, ju lutemi kontaktoni administratorin",
        departmentName01: "Emri i departamentit",
        image: "Imazh",
        music: "Muzikë",
        video: "Video",
        buySize: "Sasia e blerjes",
        totalMoney: "Shuma e pagesës",
        buycreateTime: "Koha e blerjes",
        endTime: "Koha e skadimit",
        buyTypeStr: "Lloji i porosisë",
        sourceCheck: "Verifikimi i materialeve",
        programCheck: "Verifikimi i programeve",
        programName: "Emri i programit",
        diskExpansion: "Sugjerimi: pastroni shpejt materialet e skaduar/pandorueshme gjatë përdorimit për të garantuar kapacitetin e disponueshëm të sistemit. Nëse keni nevojë për më shumë hapësirë, mund të kontaktoni furnizuesin e pajisjeve tuaja për të marrë shërbimin e zgjerimit të kapacitetit të hapësisë së ruajtjes në cloud. Ky shërbim mund të kushtonë, detajet përkatëse veprojnë sipas informacionit të distributorit.",
        selectPermission: "Ju lutemi zgjidhni autorizimet",
        checkPermission: "Ju lutemi shënohen autorizimet",
        addRole: "Shto rol",
        enterRoleName: "Ju lutemi vendosni emrin e rolit",
        roleName: "Emri i rolit",
        roleNameRequired: "Emri i rolit nuk mund të jetë i zbrazët!",
        remark: "Shënim",
        enterRemark: "Ju lutemi vendosni shënimin",
        permissionSetting: "Rregullimet e autorizimeve",
        deleteSuccess: "Fshirja u suksesua!",
        confirmToDelete: "A konfirmoni fshirjen?",
        orgName: "Emri i organizatës",
        orgNameRequired: "Emri i organizatës nuk mund të jetë i zbrazët!",
        orgRemark: "Shënim i organizatës",
        enterOrgRemark: "Ju lutemi vendosni shënimin e organizatës",
        capacityUsage: "Gjendja e përdorimit të kapacitetit",
        usedCapacity: "Kapaciteti i përdorur",
        totalCapacity: "Kapaciteti total",
        remainingCapacity: "Kapaciteti i mbetur",
        capacityExpansion: "Zgjerimi i kapacitetit",
        enable: "Aktivizuar",
        disable: "Çaktivizuar",
        userName01: "Emri i përdoruesit",
        loginTime: "Koha e hyrjes",
        ipAddress: "Adresa IP",
        loginResult: "Rezultati i hyrjes",
        selectDate: "Zgjidhni datën",
        enterDate: "Ju lutemi zgjidhni datën",
        selectStartTime: "Ju lutemi zgjidhni kohën e fillimit",
        selectEndTime: "Ju lutemi zgjidhni kohën e mbarimit",
        enterUserName: "Ju lutemi vendosni emrin e përdoruesit",
        userCount: "Numri i përdoruesve",
        roleDesc: "Përshkrimi i rolit",
        roleAuthorization: "Autorizimi i rolit",
        success: "Sukses",
        failure: "Dështim",
        time: "Kohë",
        operationContent: "Përmbajtja e operacionit",
        playCount: "Numri i luajtjeve",
        playDuration: "Koha e luajtjes",
        selectDevice: "Zgjidhni pajisje",
        enterProgramName: "Ju lutemi vendosni emrin e programit",
        serialNumber: "Numri i serisë",
        publishContentName: "Emri i përmbajtjes së publikuar",
        playMode: "Mënyra e luajtjes",
        cyclePlay: "Luaj në rrotullim",
        insertPlay: "Shtojmë luajtje",
        paddingPlay: "Luaj mbushje",
        playDeviceId: "ID e pajisjes së luajtjes",
        playDeviceName: "Emri i pajisjes së luajtjes",
        publishTime: "Koha e publikimit",
        downloadStatus: "Gjendja e ngarkimit",
        notDownloaded: "Pa ngarkim",
        downloading: "Po ngarkohet",
        downloadSucceeded: "Ngarkimi u suksesua",
        downloadFailed: "Ngarkimi dështoi",
        enterPublishContentName: "Ju lutemi vendosni emrin e përmbajtjes së publikuar",
        terminalId: "ID e terminalit",
        belongOrg: "Organizata e cila i përket",
        reportTime: "Koha e raportimit",
        reportIp: "IP e raportimit",
        logInfo: "Informacioni i regjistrit",
        details: "Detaje",
        confirmDeletion: "A konfirmoni fshirjen?",
        logDetails: "Detajet e regjistrit",
        download: "Ngarko",
        deptOrg: "Struktura e departamentit",
        query: "Kërkimi",
        queryByTerminalId: "Kërkimi sipas ID-së së terminalit",
        batchDeleteLogs: "Fshirja e grupit të regjistrave",
        customTimeDeleteLogs: "Fshirja e regjistrave me kohë të personalizuar",
        selectTimeRangeFirst: "Ju lutemi zgjidhni gamën e kohës më parë",
        deleteAllDeviceLogsIfEmpty: "Nëse nuk plotësoni ID-në e pajisjes, regjistrat e të gjitha pajisjeve do të fshihen si parazgjedhje",
        enterDeviceIdToDeleteLogs: "Ju lutemi vendosni ID-në e pajisjes për të fshirë regjistrat",
        confirmDeleteAction: "Konfirmoni fshirjen",
        selectDeleteRangeFirst: "Ju lutemi zgjidhni gamën e fshirjes më parë",
        networkConnectionFailed: "Lidhja me rrjetin dështoi",
        playLog: "Regjistri i luajtjes",
        publishLog: "Regjistri i publikimit",
        errorLog: "Regjistri i gabimeve",
        operationLog: "Regjistri i operacioneve",
        fileLog: "Regjistri i skedarëve",
        userOperateLog: "Regjistri i hyrjes"
    },
    userManual: {
        userManual: "Manuali i përdoruesit",
        noData: "Asnjë të dhënë"
    },
    systemNotice: {
        systemNotice: "Njoftimet e sistemit",
        noData: "Asnjë të dhënë",
        total: "Total",
        totalNum: "vija",
        "markAllRead": "Shëno të gjitha si të lexuar",
        "deleteAll": "Fshi të gjitha",
        "all": "Gjithë",
        "unread": "Pa lexuar",
        "read": "Të lexuar",
        "type": "Lloj",
        "content": "Përmbajtje",
        "date": "Data",
        "status": "Gjendja",
        "confirmDelete": "A konfirmoni fshirjen?",
        "confirm": "Konfirmo",
        "cancel": "Anulo",
        "delete": "Fshi"
    }
};